function getInstall (Model, addName = '') {
  return function (Vue, options = {}) {
    Model.updateOptions(options)

    Vue.mixin({
      methods : {
        /** @method fwLoadConfig */
        /** @method fwLoadUserConfig */
        [`fwLoad${addName}Config`] (name) {
          let val = this.$store.state[`${addName}Config`].configs[name]

          if (val !== undefined) return Promise.resolve(val)

          return Model.loadConfig(name)
        },
      },
      computed : {
        /** @method fwConfigs */
        /** @method fwUserConfigs */
        [`fw${addName}Configs`] () {
          return this.$store.state[`${addName}Config`].configs
        }
      }
    })

    // Global property
    /**
     * @property $fwConfig
     * @property $fwUserConfig
     */
    Vue.prototype[`$fw${addName}Config`] = new Vue({
      name: `$fw${addName}Config`,

      data : () => ({

      }),

      methods: {
        getConfig (name = '') {
          return Model.getConfig(name)
        },
        getConfigList (list = []) {
          return Model.getConfigList(list)
        },
        loadConfig (name = '') {
          return Model.loadConfig(name)
        },
        loadConfigList (list = []) {
          return Model.loadConfigList(list)
        },
      },

      created () {

      },

    })
  }
}

export default getInstall
